import React from "react";
import { TagSetOrEditCustomFieldPage } from "./TagSetOrEditCustomFieldPage";
interface CreateCustomFieldPageProps {
    spaceId: string;
}
export function CreateCustomFieldPage({ spaceId }: CreateCustomFieldPageProps) {
    return <TagSetOrEditCustomFieldPage spaceId={spaceId} create/>;
}
